import axiosInstance from "./axiosInstance";

export type LegalDocumentName = "cookie-management-policy" | "legal-notices" | "terms-of-use" | "disclaimer";
export type LegalLanguage = "en" | "fr";

export interface LegalDocumentResponse {
  content: string;
  name: string;
  lang: string;
  lastUpdated?: string;
}

export class LegalService {
  private static readonly BASE_PATH = "/app/legal";

  public static async getLegalDocument(name: LegalDocumentName, lang: LegalLanguage): Promise<LegalDocumentResponse> {
    const res = await axiosInstance.get(`${LegalService.BASE_PATH}/${name}/${lang}`);
    return res.data;
  }
}
